export default {
  nl: {
      service: {
        contextAria: "Applicatiecontext",
        admin: "Beheerder",
        logout: "Uitloggen",
        login: "Inloggen"
      },
      navigation: {
        notifications: "Meldingen via e-mail",
        notificationsHelp: "Hiermee ontvangt u meldingen via e-mail.",
        manage: "Beheer"
      },
      loading: "Gegevens worden geladen...",
      intro: {
        eyebrow: "Productie-inzichten",
        title: "Grip op elke plaat, elk onderdeel en elk project.",
        description: "Volg de actuele cijfers van {application} en ontdek trends in één helder overzicht.",
        productionFallback: "uw productie",
        productAria: "Kies een product",
        product: "Product"
      },
      overview: {
        eyebrow: "Vandaag in cijfers",
        title: "Overzicht",
        documents: "Aantal documenten",
        compositions: "Aantal composities",
        productionParts: "Productieonderdelen"
      },
      analysis: {
        eyebrow: "Verdeling",
        title: "Analyse"
      },
      history: {
        eyebrow: "Doorheen de tijd",
        title: "Historiek",
        periodAria: "Periode",
        byDay: "Per dag",
        byWeek: "Per week",
        byMonth: "Per maand",
        dateType: "Datumtype",
        productionStart: "Start productie",
        assembly: "Montage",
        delivery: "Plaatsing"
      },
      material: {
        eyebrow: "Detailoverzicht",
        title: "Materiaaltabel",
        export: "Exporteren",
        visibleColumns: "Zichtbare kolommen",
        selectColumns: "Kolommen selecteren",
        noColumns: "Geen kolommen beschikbaar",
        noResults: "Geen resultaten gevonden",
        noData: "Geen gegevens beschikbaar",
        overview: "Overzicht"
      },
      columns: {
        net: "Netto%",
        rest: "Rest%",
        scrap: "Afval%",
        cutting: "Zaagafval%",
        materialName: "Materiaalnaam",
        thickness: "Dikte",
        sheets: "Platen",
        orders: "Opdrachten",
        machines: "Machines",
        parts: "Onderdelen",
        productionMethod: "Productiemethode",
        length: "Lengte",
        width: "Breedte"
      },
      chart: {
        length: "Lengte",
        width: "Breedte",
        frequency: "Frequentie",
        bubbleTooltip: "Lengte: {length}, breedte: {width}, frequentie: {frequency}",
        weekNumber: "Week {number}",
        months: {
          Jan: "jan.", Feb: "feb.", Mar: "mrt.", Apr: "apr.", May: "mei", Jun: "jun.",
          Jul: "jul.", Aug: "aug.", Sep: "sep.", Oct: "okt.", Nov: "nov.", Dec: "dec."
        }
      },
      detailsTitle: "Details {year} - {period}",
      errors: {
        documents: "Fout bij het ophalen van de documenten: {error}",
        compositions: "Fout bij het ophalen van de composities: {error}"
      }
  },
  en: {
      service: {
        contextAria: "Application context",
        admin: "Administrator",
        logout: "Log out",
        login: "Log in"
      },
      navigation: {
        notifications: "Email notifications",
        notificationsHelp: "Enable this to receive notifications by email.",
        manage: "Manage"
      },
      loading: "Loading data...",
      intro: {
        eyebrow: "Production insights",
        title: "Control over every sheet, every part and every project.",
        description: "Track the latest figures for {application} and discover trends in one clear overview.",
        productionFallback: "your production",
        productAria: "Choose a product",
        product: "Product"
      },
      overview: {
        eyebrow: "Today's figures",
        title: "Overview",
        documents: "Number of documents",
        compositions: "Number of compositions",
        productionParts: "Production parts"
      },
      analysis: {
        eyebrow: "Distribution",
        title: "Analysis"
      },
      history: {
        eyebrow: "Over time",
        title: "History",
        periodAria: "Period",
        byDay: "By day",
        byWeek: "By week",
        byMonth: "By month",
        dateType: "Date type",
        productionStart: "Production start",
        assembly: "Assembly",
        delivery: "Installation"
      },
      material: {
        eyebrow: "Detailed overview",
        title: "Material table",
        export: "Export",
        visibleColumns: "Visible columns",
        selectColumns: "Select columns",
        noColumns: "No columns available",
        noResults: "No results found",
        noData: "No data available",
        overview: "Overview"
      },
      columns: {
        net: "Net%",
        rest: "Remnant%",
        scrap: "Waste%",
        cutting: "Cutting waste%",
        materialName: "Material name",
        thickness: "Thickness",
        sheets: "Sheets",
        orders: "Orders",
        machines: "Machines",
        parts: "Parts",
        productionMethod: "Production method",
        length: "Length",
        width: "Width"
      },
      chart: {
        length: "Length",
        width: "Width",
        frequency: "Frequency",
        bubbleTooltip: "Length: {length}, width: {width}, frequency: {frequency}",
        weekNumber: "Week {number}",
        months: {
          Jan: "Jan", Feb: "Feb", Mar: "Mar", Apr: "Apr", May: "May", Jun: "Jun",
          Jul: "Jul", Aug: "Aug", Sep: "Sep", Oct: "Oct", Nov: "Nov", Dec: "Dec"
        }
      },
      detailsTitle: "Details {year} - {period}",
      errors: {
        documents: "Could not retrieve the documents: {error}",
        compositions: "Could not retrieve the compositions: {error}"
      }
  },
  fr: {
      service: {
        contextAria: "Contexte de l’application",
        admin: "Administrateur",
        logout: "Se déconnecter",
        login: "Se connecter"
      },
      navigation: {
        notifications: "Notifications par e-mail",
        notificationsHelp: "Activez cette option pour recevoir les notifications par e-mail.",
        manage: "Gestion"
      },
      loading: "Chargement des données...",
      intro: {
        eyebrow: "Aperçu de la production",
        title: "Maîtrisez chaque panneau, chaque pièce et chaque projet.",
        description: "Suivez les chiffres actuels de {application} et découvrez les tendances dans une vue d’ensemble claire.",
        productionFallback: "votre production",
        productAria: "Choisir un produit",
        product: "Produit"
      },
      overview: {
        eyebrow: "Les chiffres du jour",
        title: "Vue d’ensemble",
        documents: "Nombre de documents",
        compositions: "Nombre de compositions",
        productionParts: "Pièces de production"
      },
      analysis: {
        eyebrow: "Répartition",
        title: "Analyse"
      },
      history: {
        eyebrow: "Évolution dans le temps",
        title: "Historique",
        periodAria: "Période",
        byDay: "Par jour",
        byWeek: "Par semaine",
        byMonth: "Par mois",
        dateType: "Type de date",
        productionStart: "Début de production",
        assembly: "Assemblage",
        delivery: "Installation"
      },
      material: {
        eyebrow: "Vue détaillée",
        title: "Tableau des matériaux",
        export: "Exporter",
        visibleColumns: "Colonnes visibles",
        selectColumns: "Sélectionner les colonnes",
        noColumns: "Aucune colonne disponible",
        noResults: "Aucun résultat trouvé",
        noData: "Aucune donnée disponible",
        overview: "Vue d’ensemble"
      },
      columns: {
        net: "Net %",
        rest: "Chute réutilisable %",
        scrap: "Déchet %",
        cutting: "Trait de scie %",
        materialName: "Nom du matériau",
        thickness: "Épaisseur",
        sheets: "Panneaux",
        orders: "Commandes",
        machines: "Machines",
        parts: "Pièces",
        productionMethod: "Méthode de production",
        length: "Longueur",
        width: "Largeur"
      },
      chart: {
        length: "Longueur",
        width: "Largeur",
        frequency: "Fréquence",
        bubbleTooltip: "Longueur : {length}, largeur : {width}, fréquence : {frequency}",
        weekNumber: "Semaine {number}",
        months: {
          Jan: "janv.", Feb: "févr.", Mar: "mars", Apr: "avr.", May: "mai", Jun: "juin",
          Jul: "juil.", Aug: "août", Sep: "sept.", Oct: "oct.", Nov: "nov.", Dec: "déc."
        }
      },
      detailsTitle: "Détails {year} - {period}",
      errors: {
        documents: "Erreur lors de la récupération des documents : {error}",
        compositions: "Erreur lors de la récupération des compositions : {error}"
      }
  },
  de: {
      service: {
        contextAria: "Anwendungskontext",
        admin: "Administrator",
        logout: "Abmelden",
        login: "Anmelden"
      },
      navigation: {
        notifications: "E-Mail-Benachrichtigungen",
        notificationsHelp: "Aktivieren Sie diese Option, um Benachrichtigungen per E-Mail zu erhalten.",
        manage: "Verwalten"
      },
      loading: "Daten werden geladen...",
      intro: {
        eyebrow: "Produktionseinblicke",
        title: "Jede Platte, jedes Teil und jedes Projekt im Griff.",
        description: "Verfolgen Sie die aktuellen Kennzahlen für {application} und erkennen Sie Trends in einer klaren Übersicht.",
        productionFallback: "Ihre Produktion",
        productAria: "Produkt auswählen",
        product: "Produkt"
      },
      overview: {
        eyebrow: "Heutige Kennzahlen",
        title: "Übersicht",
        documents: "Anzahl Dokumente",
        compositions: "Anzahl Kompositionen",
        productionParts: "Produktionsteile"
      },
      analysis: {
        eyebrow: "Verteilung",
        title: "Analyse"
      },
      history: {
        eyebrow: "Im Zeitverlauf",
        title: "Verlauf",
        periodAria: "Zeitraum",
        byDay: "Pro Tag",
        byWeek: "Pro Woche",
        byMonth: "Pro Monat",
        dateType: "Datumstyp",
        productionStart: "Produktionsstart",
        assembly: "Montage",
        delivery: "Installation"
      },
      material: {
        eyebrow: "Detailübersicht",
        title: "Materialtabelle",
        export: "Exportieren",
        visibleColumns: "Sichtbare Spalten",
        selectColumns: "Spalten auswählen",
        noColumns: "Keine Spalten verfügbar",
        noResults: "Keine Ergebnisse gefunden",
        noData: "Keine Daten verfügbar",
        overview: "Übersicht"
      },
      columns: {
        net: "Netto%",
        rest: "Reststück%",
        scrap: "Abfall%",
        cutting: "Schnittverlust%",
        materialName: "Materialname",
        thickness: "Dicke",
        sheets: "Platten",
        orders: "Aufträge",
        machines: "Maschinen",
        parts: "Teile",
        productionMethod: "Produktionsmethode",
        length: "Länge",
        width: "Breite"
      },
      chart: {
        length: "Länge",
        width: "Breite",
        frequency: "Häufigkeit",
        bubbleTooltip: "Länge: {length}, Breite: {width}, Häufigkeit: {frequency}",
        weekNumber: "Woche {number}",
        months: {
          Jan: "Jan.", Feb: "Feb.", Mar: "März", Apr: "Apr.", May: "Mai", Jun: "Juni",
          Jul: "Juli", Aug: "Aug.", Sep: "Sept.", Oct: "Okt.", Nov: "Nov.", Dec: "Dez."
        }
      },
      detailsTitle: "Details {year} - {period}",
      errors: {
        documents: "Fehler beim Abrufen der Dokumente: {error}",
        compositions: "Fehler beim Abrufen der Kompositionen: {error}"
      }
  }
};
